import Cookies from 'js-cookie';

export default function getUPrefValue(key) {
  const raw = Cookies.get('uPref');
  if (!raw) return '';
  const parsed = JSON.parse(raw);
  return parsed?.[key] ?? '';
}
